export default {"src":"/_next/static/media/twitter-white.d75c2dd0.svg","height":12,"width":12};